import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocalStorageService } from '../core/services/local-storage.service';

/**
 * Endpoints that must be called without a language: the site nudge API
 * (`/nudges-recommendation/site` and `/site/descriptions`) takes the target
 * only and reads the rest from the merchant record.
 */
const NO_LANGUAGE_ENDPOINTS = ['/nudges-recommendation/site'];

/**
 * Adds language query param when calling endpoints:
 *  - language (localStorage → default 'en')
 */
export const LangParamsInterceptor: HttpInterceptorFn = (req, next) => {
  const path = req.url.split('?')[0];
  if (NO_LANGUAGE_ENDPOINTS.some((endpoint) => path.includes(endpoint))) {
    return next(req);
  }

  const localStorageService = inject(LocalStorageService);
  const language: string = localStorageService.get('language') || 'en';

  const hasLangInParams = req.params.has('language') || req.params.has('lang');
  const hasLangInUrl =
    req.url.includes('language=') || req.url.includes('lang=');

  if (hasLangInParams || hasLangInUrl) {
    return next(req);
  }

  const setParams: Record<string, string> = { language };
  return next(req.clone({ setParams }));
};
